import { Link, useLocation } from "react-router-dom";
import {
  ShieldCheckIcon,
  ListBulletIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "@/application/services/authService";
import { ROUTES } from "@/domain/constants/routes";

/**
 * 對話頁面導航欄
 * 顯示 Logo、助手資訊和選單按鈕
 * 完全匹配 chat.html 的樣式和功能
 */
export function ApplicationMenuModal({
  isMenuOpen,
  setIsMenuOpen,
}: {
  isMenuOpen: boolean;
  setIsMenuOpen: (open: boolean) => void;
}) {
  const { logout } = useAuth();
  const currentRoute = useLocation().pathname;

  return (
    <>
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-50"
          onClick={() => setIsMenuOpen(false)}
        >
          <div
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl p-6 animate-slide-up"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-6"></div>

            <div className="space-y-4">
              <button
                onClick={logout}
                className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors w-full"
              >
                <ArrowRightOnRectangleIcon className="w-5 h-5 text-[#6B8E5A]" />
                <span className="text-[#A0956B]">登出</span>
              </button>

              {/* TODO */}
              {![ROUTES.ACCOUNT_INIT, ROUTES.AGENTS].includes(currentRoute) && (
                <Link
                  to={ROUTES.AGENTS}
                  className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <ListBulletIcon className="w-5 h-5 text-[#6B8E5A]" />
                  <span className="text-[#A0956B]">服務列表</span>
                </Link>
              )}

              <Link
                to="/terms"
                className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <ShieldCheckIcon className="w-5 h-5 text-[#6B8E5A]" />
                <span className="text-[#A0956B]">服務條款</span>
              </Link>

              <Link
                to="/privacy"
                className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <ShieldCheckIcon className="w-5 h-5 text-[#6B8E5A]" />
                <span className="text-[#A0956B]">隱私政策</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
